<template>
  <v-container>
    <v-card class="pt-7 pb-7" flat>
      <v-card-title>
        <h3 class="title">
          {{ $t(`components.login.${component}.title`) }}
        </h3>
      </v-card-title>
      <v-card-text>
        <slot />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class LoginComponentLayout extends Vue {
  @Prop()
  component!: string;
}
</script>

<style scoped>
.title {
  word-break: break-word;
  font-weight: 900;
}
</style>
